// © Microsoft Corporation. All rights reserved.

export const elementKey = {
    addTopSiteButton: "addTopSiteButton",
    backgroundOuterHolder: "backgroundOuterHolder",
    backgroundInnerHolder: "backgroundInnerHolder",
    feedToggle: "feedToggle",
    headerSpaceHolder: "headerSpaceHolder",
    marketSelector: "marketSelector",
    navBar: "navBar",
    recommendedSites: "recommendedSites",
    rewardsIcon: "rewardsIcon",
    rightRailSectionKey: "rightRailSectionKey",
    searchBox: "searchBox",
    searchBoxVoiceButton: "searchBoxVoiceButton",
    settingsButton: "SettingsButton",
    topSites: "topSites",
    topSitesFirstLink: "quicklinksFirstLink",
    topSitePlaceHolder: "topSitePlaceHolder",
    waffle: "waffle"
};